// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import moment from 'moment';
import { connect } from 'react-redux';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

// Internal Dependencies
import { Status } from '../../common/constants';
import { IsEmpty } from '../../common/checks';
import Colours from '../../styles/colours';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding:  theme.spacing(2),
    margin:   'auto',
    maxWidth: '100%',
  },
  image: {
    width:  '100%',
    height: 'fit-content',
  },
  img: {
    margin:    'auto',
    display:   'block',
    maxWidth:  '100%',
    maxHeight: '100%',
  },
}));

const FreeAd = ({ id, title, isTakeaway, isDelivery, orderInfo, photo, address, pageName, contact, terms, status, lastUpdatedBy, createdAt, onAcceptClicked, onRejectClicked, onRevertClicked }) => {
  const [popUpImage, setImage] = useState('');
  const classes = useStyles();

  function showModal(image) {
    setImage(image);
  }

  return (
    <div className={classes.root}>
      {popUpImage && (
        <Lightbox
          animationDisabled
          mainSrc={popUpImage}
          onCloseRequest={() => {
            setImage('');
          }}
        />
      )}
      <Paper className={classes.paper}>
        <Grid container spacing={2} direction="row">
          <Grid item container xs={12} md={3} className={classes.image}>
            {
              (!IsEmpty(photo))
                ? (
                  <>
                    <div style={{ position: 'relative', border: `1px solid ${Colours.LightGray}`, width: '100%', maxWidth: '280px', height: 'auto' }}>
                      <img
                        className={classes.img}
                        style={{
                          width:     'auto',
                          height:    'auto',
                          maxHeight: 280,
                        }}
                        alt="photo"
                        src={photo}
                        onClick={() => showModal(photo)}
                      />
                    </div>
                  </>
                )
                : <Typography variant="h6">No photo</Typography>
            }
          </Grid>

          <Grid item xs={12} md={9} sm container>
            <Grid item xs direction="row" container>
              <Grid item xs={12} sm={12} lg={8}>
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">ID:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{id}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Created at:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{moment(createdAt).format('YYYY-MM-DD hh:mm') }</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Takeaway:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{isTakeaway ? 'Yes' : 'No'}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Delivery:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{isDelivery ? 'Yes' : 'No'}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Promotional offer:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{title}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Order Information:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{orderInfo}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Terms:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{terms || '-'}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Addresses:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{ address || '-' }</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Shop name:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{pageName}</strong></p>
                        </div>
                      </td>
                    </tr>

                    <tr className="d-block mb-3">
                      <td className="row">
                        <div className="col-12 col-lg-4 col-xl-3">
                          <p className="d-block">Contact Information:</p>
                        </div>
                        <div className="col-12 col-lg-8 col-xl-9">
                          <p><strong>{contact}</strong></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>

              <Grid item xs={12} sm={12} lg={4} container alignItems="center" direction="row">
                <div>
                  <div className="d-flex flex-row justify-content-center">
                    <p className="d-block">Status:</p>
                    <p className="ml-3"><strong>{ status }</strong></p>
                  </div>
                  <hr />
                  <div className="d-flex flex-row justify-content-center">
                    <p className="d-block">Last updated by:</p>
                    <p className="ml-3"><strong>{ lastUpdatedBy || '-' }</strong></p>
                  </div>
                  <hr />
                  <div className="text-center mt-4" style={{ width: '100%' }}>
                    {
                      // Only status that was Expired or Rejected can be reverted back to Pending status
                      [Status.Pending].includes(status) && (
                        <Button disabled={status !== Status.Pending} onClick={() => onRejectClicked()} variant="contained" color="secondary" className="mx-3">Reject</Button>
                      )
                    }

                    <Button disabled={status !== Status.Pending} onClick={() => onAcceptClicked()} variant="contained" color="primary" className="mr-3">Accept</Button>

                    {
                      // Only status that was Expired or Rejected can be reverted back to Pending status
                      [Status.Rejected].includes(status) && (
                        <Button onClick={() => onRevertClicked()} variant="contained" color="secondary" className="mr-3">Revert</Button>
                      )
                    }
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Paper>

    </div>
  );
};

FreeAd.postTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null)(FreeAd);
